import * as React from "react";
import classNames from "classnames";
import css from "./severity-pill.scss";

export enum Severity {
    SEVERE = "severe",
    MEDIUM = "medium",
    LIGHT = "light",
    WARNING = "warning",
    DANGER = "danger",
}

export interface SeverityPillProps {
    readonly severity: Severity;
    readonly label: string;
}

export class SeverityPill extends React.Component<SeverityPillProps> {
    public render(): JSX.Element {
        return (
            <span
                className={classNames(css.severityPill, {
                    [css["severityPill--severe"]]:
                        this.props.severity === Severity.SEVERE ||
                        this.props.severity === Severity.DANGER,
                    [css["severityPill--medium"]]:
                        this.props.severity === Severity.MEDIUM ||
                        this.props.severity === Severity.WARNING,
                    [css["severityPill--light"]]: this.props.severity === Severity.LIGHT,
                })}
            >
                {this.props.label}
            </span>
        );
    }
}
